import { APICall, GetRequest } from "../service"

const ControllerName = "Country"

export const GetCountryLookup = () =>
    GetRequest(`${ControllerName}/lookup`)


export const GetNationalitiesLookup = () =>
    GetRequest(`${ControllerName}/nationality/lookup`)
